<template>
  <div class="content">
        <el-row :gutter="24" class="row">
          <!-- <el-col :span="15">
            <div class="block">
              <div class="title">
                <span>窗口验票</span>
              </div>
              <div>
                <el-row style="margin-top:10px">
                  <el-col :span="4" style="font-size:38px;">票号</el-col>

                  <el-col :span="13">
                    <el-input
                      v-model="checkSn"
                      placeholder="请用扫码枪扫描二维码或手工输入票号"
                      style="width:100%;height:50px;line-height: 50px;ime-mode:disabled"
                      @keyup.enter.native="goCheck"
                      v-focus
                    ></el-input>
                  </el-col>

                  <el-col :span="6">
                    <el-button type="primary" style="height:50px;" plain @click="goCheck">校验</el-button>
                    <el-button type="danger" style="height:50px;" plain @click="cleanSn">清除</el-button>
                  </el-col>
                </el-row>
                <el-row style="width:95%;margin: 10px auto">
                  <el-card class="box-card" shadow="never">
                    <div v-if="ticket == ''">{{msg}}</div>
                    <div v-if="ticket != ''">
                      <el-row>
                        <el-col :span="8">
                          <span style="color:gray;font-size:20px;">票种：</span>
                          <span
                            style="font-size:22px;"
                          >{{CommonUtil.getCodeValue("ticket_type", ticket.type)}}</span>
                        </el-col>

                        <el-col :span="8">
                          <span style="color:gray;font-size:20px;">票价：</span>
                          <span style="font-size:22px;">￥{{ticket.price}}</span>
                        </el-col>

                        <el-col :span="8">
                          <span style="color:gray;font-size:20px;">购票渠道：</span>
                          <span
                            style="font-size:22px;"
                          >{{CommonUtil.getCodeValue("ticket_from", ticket.from)}}</span>
                        </el-col>
                      </el-row>

                      <el-row style="margin-top:10px;">
                        <el-col :span="8">
                          <span style="color:gray;font-size:20px;">购票日期：</span>
                          <span style="font-size:22px;">{{new Date(ticket.createTime).toLocaleString().replace(/:\d{1,2}$/,' ')}}</span>
                        </el-col>

                        <el-col :span="8">
                          <span style="color:gray;font-size:20px;">失效日期：</span>
                          <span style="font-size:22px;">{{new Date(ticket.endTime).toLocaleString().replace(/:\d{1,2}$/,' ')}}</span>
                        </el-col>

                        <el-col :span="8">
                          <span style="color:gray;font-size:20px;">人数：</span>
                          <span style="font-size:22px;">{{ticket.num}}</span>
                        </el-col>
                      </el-row>

                      <el-row style="margin-top:10px;">
                        <el-col :span="24" v-if="ticket.status == 1">
                          <el-button
                            type="success"
                            style="height:60px;width:90%;font-size:30px;"
                            @click="consume"
                          >门票有效！点击立即消费不可撤销</el-button>
                        </el-col>

                        <el-col :span="24" v-if="ticket.status == 2">
                          <el-button
                            type="danger"
                            disabled
                            style="height:60px;width:90%;font-size:30px;"
                          >{{ticket.statusStr}}</el-button>
                        </el-col>
                      </el-row>
                    </div>
                  </el-card>
                </el-row>
              </div>
            </div>
          </el-col> -->

          <el-col :span="15">
            <div class="block">
              <div class="title">
                <span>当日进园游客量</span>
              </div>
              <div id="div1" style="height: 100%"></div>
            </div>
          </el-col>

          <el-col :span="9">
            <div class="block">
              <div class="title">
                <span>日历</span>
              </div>
              <el-calendar v-model="date" />
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="24" class="row row-bottom">
          <el-col :span="12">
            <div class="block">
              <div class="title">
                <span>当日进园游客按种类分布</span>
              </div>
              <div id="div2" style="height: 100%"></div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="block">
              <div class="title">
                <span>当日进园游客按来源分布</span>
              </div>
              <div id="div3" style="height: 100%"></div>
            </div>
          </el-col>
        </el-row>


  </div>
</template>

<script>
export default {
  components: {},

  mounted: function() {
    this.div1=this.$echarts.init(document.getElementById('div1'));
    this.div2=this.$echarts.init(document.getElementById('div2'));
    this.div3=this.$echarts.init(document.getElementById('div3'));

    var userInfo = this.CommonUtil.getUserInfo();
    this.userId = userInfo.userId;

    var tempDate;
    var legendTemp = [];
    var seriesTemp = [];
    var optionTemp = {};
    var that = this;

    this.$axios.get('/chart/getIndexChart').then(res => {
        tempDate = res.data.pie1;
        legendTemp = [];
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
        }
        optionTemp = {
            title: {
                text: '',
                subtext: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c}人 ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: legendTemp
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '45%'],
                    data: tempDate,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }
        that.div2.setOption(optionTemp);

        legendTemp = [];
        tempDate = res.data.pie2;
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
        }
        optionTemp = {
            title: {
                text: '',
                subtext: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c}人 ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: legendTemp
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '45%'],
                    data: tempDate,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }
        that.div3.setOption(optionTemp);

        tempDate = res.data.bar1;
        legendTemp = [];
        seriesTemp = [];
        for (var i = 0; i < tempDate.length; i++) {
          legendTemp.push(tempDate[i]["name"]);
          seriesTemp.push(tempDate[i]["value"]);
        }
        optionTemp = {
          title: {
            text: "",
            subtext: "",
            left: "center"
          },
          xAxis: {
            type: "category",
            name: '时间整点',
            data: legendTemp,
            axisLabel: {
              interval: 0,
              // rotate: -50
            }
          },
          yAxis: {
            type: "value",
            name: '人数',
          },
          series: [
            {
              type: "bar",
              data: seriesTemp,
              label: {
                show: true,
                position: "top"
              },
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" }
                ])
              }
            }
          ]
        };
        that.div1.setOption(optionTemp);

      })

  },
  data() {
    return {
      date: new Date(),
      userId: "",
      checkSn: "",
      ticket: "",
      msg: "等待输入门票编号...",
      div1: '',
      div2: '',
      div3: '',
    };
  },
  // watch: {
  //   page: function(newObj, oleObj) {
  //     page.totalElements = newObj;
  //   }},
  methods: {
    //获取首面数据
    getIndex() {
      var url = "/Total/getIndex?userId=" + this.userId;
      var self = this;
      this.$axios.get(url).then(res => {});
    },
    goCheck() {
      if (this.checkSn == "" || this.checkSn == null) {
        this.$message({
          message: "请填写门票编号",
          type: "error"
        });
        return;
      }
      // if(this.checkSn == '1'){
      //   this.ticket = {
      //     type: '团购票',
      //     price: '160',
      //     num: '4',
      //     createTime: '2020-02-01',
      //     endTime: '2020-08-01',
      //     status: 1,
      //     statusStr: '有效'
      //   }
      // }else{
      //   this.ticket = {
      //     type: '团购票',
      //     price: '160',
      //     num: '4',
      //     createTime: '2020-01-01',
      //     endTime: '2020-06-01',
      //     status: 2,
      //     statusStr: '无效'
      //   }
      // }
      let that = this;
      this.$axios.get("/ticket/check/" + that.checkSn).then(res => {
        if (res.code == "0000") {
          that.ticket = res.data;
        } else {
          this.cleanSn();
          that.msg = res.message;
        }
      });
    },
    cleanSn() {
      this.checkSn = "";
      this.ticket = "";
      this.msg = "等待输入门票编号...";
    },
    consume() {
      let that = this;
      if (this.checkSn == "" || this.checkSn == null) {
        this.$message({
          message: "请填写门票编号",
          type: "error"
        });
        return;
      }
      this.$axios.get("/ticket/consume/" + that.checkSn).then(res => {
        if (res.code == "0000") {
          this.$message({
            message: "消费成功，请打印门票",
            type: "success"
          });
          this.cleanSn();
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  overflow-y: auto;
  background-color: #fff;
}

.block {
  width: 100%;
  height: 400px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  overflow: hidden;
}

.title {
  text-align: left;
  border-bottom: 1px solid #cccccc;
  padding: 10px;
  font-weight: bold;
}

.row {
  padding-left: 20px;
  padding-right: 20px;
}

.row-center {
  margin-top: 20px;
}

.row-bottom {
  margin-top: 20px;
  margin-bottom: 150px;
}

li:hover {
  cursor: pointer;
  color: rgba(33, 128, 209, 0.6);
}

/*滚动条样式*/
::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(64, 158, 255, 0.8);
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

/deep/ .el-calendar-table .el-calendar-day {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 8px;
  height: 35px;
}

/deep/ .el-calendar-table td.is-selected {
  background-color: rgba(33, 128, 209, 0.6);
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue